export const data = [
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב אלחדיף לסמטת ציפורי",
     "Resion":"אבועלפיה",
     "CityName":"טבריה",
     "Position1":"32°47'25.8\"N 35°32'10.4\"E",
     "Position2":"32°47'25.3\"N 35°32'16.1\"E",
     "Position3":"32°47'24.5\"N 35°32'22.0\"E",
     "Position4":"32°47'24.3\"N 35°32'22.1\"E",
     "Position5":"32°47'25.1\"N 35°32'16.4\"E",
     "Position6":"32°47'25.4\"N 35°32'10.4\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב אלחדיף לרחוב בן זכאי",
     "Resion":"אילת",
     "CityName":"טבריה",
     "Position1":"32°47'20.5\"N 35°32'18.6\"E",
     "Position2":"32°47'22.3\"N 35°32'23.2\"E",
     "Position3":"32°47'22.1\"N 35°32'23.3\"E",
     "Position4":"32°47'20.3\"N 35°32'18.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב המגינים לרחוב הירדן",
     "Resion":"אלחדיף",
     "CityName":"טבריה",
     "Position1":"32°47'31.0\"N 35°32'10.7\"E",
     "Position2":"32°47'26.5\"N 35°32'20.9\"E",
     "Position3":"32°47'23.6\"N 35°32'23.4\"E",
     "Position4":"32°47'18.2\"N 35°32'25.5\"E",
     "Position5":"32°47'18.1\"N 35°32'24.7\"E",
     "Position6":"32°47'23.2\"N 35°32'22.9\"E",
     "Position7":"32°47'25.9\"N 35°32'20.6\"E",
     "Position8":"32°47'28.3\"N 35°32'14.1\"E",
     "Position9":"32°47'30.4\"N 35°32'10.2\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש נסלל על קברים",
     "Area":"מהכיכר שברחוב הירדן כ-20 מטר צפונה",
     "Resion":"גדוד ברק כביש 90",
     "CityName":"טבריה",
     "Position1":"32°47'19.9\"N 35°32'30.3\"E",
     "Position2":"32°47'18.8\"N 35°32'29.7\"E",
     "Position3":"32°47'19.2\"N 35°32'29.4\"E",
     "Position4":"32°47'20.0\"N 35°32'29.8\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב המגינים לרחוב הפלמ\"ח",
     "Resion":"גולני",
     "CityName":"טבריה",
     "Position1":"32°47'31.0\"N 35°32'14.1\"E",
     "Position2":"32°47'32.7\"N 35°32'21.0\"E",
     "Position3":"32°47'35.6\"N 35°32'23.3\"E",
     "Position4":"32°47'35.1\"N 35°32'23.5\"E",
     "Position5":"32°47'32.4\"N 35°32'21.3\"E",
     "Position6":"32°47'30.7\"N 35°32'14.3\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"מהכיכר שברחוב הירדן עד אחרי מלון כהן",
     "Resion":"דונה גרציה",
     "CityName":"טבריה",
     "Position1":"32°47'28.5\"N 35°32'28.0\"E",
     "Position2":"32°47'26.1\"N 35°32'27.7\"E",
     "Position3":"32°47'19.5\"N 35°32'27.8\"E",
     "Position4":"32°47'18.9\"N 35°32'28.8\"E",
     "Position5":"32°47'18.7\"N 35°32'28.7\"E",
     "Position6":"32°47'19.1\"N 35°32'27.8\"E",
     "Position7":"32°47'19.5\"N 35°32'27.5\"E",
     "Position8":"32°47'24.1\"N 35°32'27.4\"E",
     "Position9":"32°47'26.5\"N 35°32'27.4\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב הירדן לרחוב הירקון בחלקו",
     "Resion":"הבנים",
     "CityName":"טבריה",
     "Position1":"32°47'17.3\"N 35°32'25.0\"E",
     "Position2":"32°47'17.4\"N 35°32'25.8\"E",
     "Position3":"32°47'13.6\"N 35°32'27.3\"E",
     "Position4":"32°47'13.4\"N 35°32'26.8\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב אלחדיף לרחוב הפלמ\"ח",
     "Resion":"הופיין",
     "CityName":"טבריה",
     "Position1":"32°47'28.3\"N 35°32'16.1\"E",
     "Position2":"32°47'29.0\"N 35°32'17.9\"E",
     "Position3":"32°47'29.4\"N 35°32'21.8\"E",
     "Position4":"32°47'29.1\"N 35°32'23.3\"E",
     "Position5":"32°47'28.9\"N 35°32'23.2\"E",
     "Position6":"32°47'29.2\"N 35°32'21.8\"E",
     "Position7":"32°47'28.8\"N 35°32'17.6\"E",
     "Position8":"32°47'28.2\"N 35°32'16.4\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב הבנים לכיכר ברחוב גדוד ברק כביש 90",
     "Resion":"הירדן",
     "CityName":"טבריה",
     "Position1":"32°47'17.2\"N 35°32'22.1\"E",
     "Position2":"32°47'17.8\"N 35°32'21.9\"E",
     "Position3":"32°47'18.8\"N 35°32'29.7\"E",
     "Position4":"32°47'18.3\"N 35°32'29.8\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב הפרחים לרחוב הבנים",
     "Resion":"הירקון",
     "CityName":"טבריה",
     "Position1":"32°47'12.3\"N 35°32'23.6\"E",
     "Position2":"32°47'12.9\"N 35°32'27.1\"E",
     "Position3":"32°47'12.7\"N 35°32'27.2\"E",
     "Position4":"32°47'12.1\"N 35°32'23.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב אלחדיף עד מסדה",
     "Resion":"המגינים",
     "CityName":"טבריה",
     "Position1":"32°47'29.9\"N 35°32'12.7\"E",
     "Position2":"32°47'31.4\"N 35°32'13.9\"E",
     "Position3":"32°47'36.2\"N 35°32'14.7\"E",
     "Position4":"32°47'36.7\"N 35°32'15.2\"E",
     "Position5":"32°47'30.6\"N 35°32'14.3\"E",
     "Position6":"32°47'29.5\"N 35°32'13.3\"E"
  },
  {
     "Code":"ג",
     "Description":"יש היתכנות לטומאה מקברים",
     "Area":"חנין מלון אביב",
     "Resion":"הנוטר",
     "CityName":"טבריה",
     "Position1":"32°47'00.6\"N 35°32'32.3\"E",
     "Position2":"32°47'00.4\"N 35°32'33.3\"E",
     "Position3":"32°46'59.7\"N 35°32'33.3\"E",
     "Position4":"32°47'00.1\"N 35°32'32.1\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב הירדן לכיכר של רחוב 335",
     "Resion":"העמקים",
     "CityName":"טבריה",
     "Position1":"32°47'20.1\"N 35°32'07.5\"E",
     "Position2":"32°47'19.9\"N 35°32'12.4\"E",
     "Position3":"32°47'19.5\"N 35°32'14.2\"E",
     "Position4":"32°47'18.6\"N 35°32'15.3\"E",
     "Position5":"32°47'17.9\"N 35°32'15.7\"E",
     "Position6":"32°47'16.8\"N 35°32'15.9\"E",
     "Position7":"32°47'16.8\"N 35°32'15.5\"E",
     "Position8":"32°47'17.9\"N 35°32'15.4\"E",
     "Position9":"32°47'19.0\"N 35°32'14.3\"E"
  },
  {
     "Code":"א",
     "Description":"נסלל על קברים",
     "Area":"איזור החניון שמול קבר הרמב\"ם",
     "Resion":"מערבית לבן זכאי",
     "CityName":"טבריה",
     "Position1":"32°47'21.4\"N 35°32'16.4\"E",
     "Position2":"32°47'20.2\"N 35°32'15.3\"E",
     "Position3":"32°47'22.1\"N 35°32'10.3\"E",
     "Position4":"32°47'24.1\"N 35°32'11.5\"E"
  },
  {
     "Code":"א",
     "Description":"נסלל על קברים",
     "Area":"מהכיכר של גולני עד בנין 26",
     "Resion":"הצנחנים",
     "CityName":"טבריה",
     "Position1":"32°47'32.0\"N 35°32'17.8\"E",
     "Position2":"32°47'34.9\"N 35°32'18.7\"E",
     "Position3":"32°47'37.9\"N 35°32'18.8\"E",
     "Position4":"32°47'38.2\"N 35°32'19.1\"E",
     "Position5":"32°47'34.8\"N 35°32'19.1\"E",
     "Position6":"32°47'32.2\"N 35°32'18.5\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב אילת לרחוב הירדן",
     "Resion":"העצמאות",
     "CityName":"טבריה",
     "Position1":"32°47'20.9\"N 35°32'20.4\"E",
     "Position2":"32°47'21.0\"N 35°32'20.6\"E",
     "Position3":"32°47'20.2\"N 35°32'21.0\"E",
     "Position4":"32°47'17.7\"N 35°32'21.8\"E",
     "Position5":"32°47'17.6\"N 35°32'21.5\"E",
     "Position6":"32°47'20.1\"N 35°32'20.8\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב תג'ר לרחוב גולני",
     "Resion":"הפלמ\"ח",
     "CityName":"טבריה",
     "Position1":"32°47'35.4\"N 35°32'24.0\"E",
     "Position2":"32°47'32.6\"N 35°32'24.9\"E",
     "Position3":"32°47'29.1\"N 35°32'23.8\"E",
     "Position4":"32°47'25.3\"N 35°32'23.8\"E",
     "Position5":"32°47'25.3\"N 35°32'23.1\"E",
     "Position6":"32°47'30.2\"N 35°32'23.3\"E",
     "Position7":"32°47'33.0\"N 35°32'24.3\"E",
     "Position8":"32°47'35.1\"N 35°32'23.5\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"מכיכר הכניסה הצפונית לטבריה (מכיוון מגדל) כ-300 מטר דרומה",
     "Resion":"הפלמ\"ח",
     "CityName":"טבריה"
  },
  {
     "Code":"ג",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב סמדג'א לרחוב הירקון",
     "Resion":"הפרחים",
     "CityName":"טבריה",
     "Position1":"32°47'11.1\"N 35°32'17.5\"E",
     "Position2":"32°47'12.2\"N 35°32'23.2\"E",
     "Position3":"32°47'11.9\"N 35°32'23.3\"E",
     "Position4":"32°47'10.9\"N 35°32'17.6\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש סלול על קברי גויים",
     "Area":"בין רחוב אחווה לרחוב אליעזר קפלן",
     "Resion":"השילוח",
     "CityName":"טבריה",
     "Position1":"32°46'52.8\"N 35°32'29.4\"E",
     "Position2":"32°46'47.1\"N 35°32'31.3\"E",
     "Position3":"32°46'47.0\"N 35°32'30.7\"E",
     "Position4":"32°46'52.6\"N 35°32'29.0\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב אלחדיף לרחוב בן זכאי",
     "Resion":"התנאים",
     "CityName":"טבריה",
     "Position1":"32°47'27.4\"N 35°32'16.6\"E",
     "Position2":"32°47'23.7\"N 35°32'16.4\"E",
     "Position3":"32°47'22.5\"N 35°32'16.0\"E",
     "Position4":"32°47'22.7\"N 35°32'15.8\"E",
     "Position5":"32°47'25.1\"N 35°32'16.1\"E",
     "Position6":"32°47'27.5\"N 35°32'16.4\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש נסלל על קברים",
     "Area":"כולו",
     "Resion":"חניון מלון רימונים",
     "CityName":"טבריה",
     "Position1":"32°47'02.8\"N 35°32'36.2\"E",
     "Position2":"32°47'00.5\"N 35°32'36.5\"E",
     "Position3":"32°47'00.4\"N 35°32'36.0\"E",
     "Position4":"32°47'02.0\"N 35°32'33.6\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב הפרחים לרחוב הירדן",
     "Resion":"סמדג'א",
     "CityName":"טבריה",
     "Position1":"32°47'15.9\"N 35°32'16.2\"E",
     "Position2":"32°47'11.2\"N 35°32'17.6\"E",
     "Position3":"32°47'11.1\"N 35°32'17.2\"E",
     "Position4":"32°47'15.8\"N 35°32'15.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב בן זכאי עד סופו",
     "Resion":"סמטת ציפורי",
     "CityName":"טבריה",
     "Position1":"32°47'25.6\"N 35°32'10.1\"E",
     "Position2":"32°47'29.7\"N 35°32'09.6\"E",
     "Position3":"32°47'30.4\"N 35°32'10.2\"E",
     "Position4":"32°47'29.6\"N 35°32'09.9\"E",
     "Position5":"32°47'25.4\"N 35°32'10.3\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב אלחדיף לרחוב דונה גרציה",
     "Resion":"תג'ר",
     "CityName":"טבריה",
     "Position1":"32°47'25.1\"N 35°32'22.5\"E",
     "Position2":"32°47'25.2\"N 35°32'23.7\"E",
     "Position3":"32°47'25.3\"N 35°32'27.5\"E",
     "Position4":"32°47'25.1\"N 35°32'27.5\"E",
     "Position5":"32°47'25.0\"N 35°32'23.5\"E",
     "Position6":"32°47'24.6\"N 35°32'22.8\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בפינה הגובלת עם רחוב הירדן",
     "Resion":"הגליל",
     "CityName":"טבריה",
     "Position1":"32°47'17.3\"N 35°32'21.8\"E",
     "Position2":"32°47'17.5\"N 35°32'22.8\"E",
     "Position3":"32°47'17.0\"N 35°32'22.5\"E",
     "Position4":"32°47'17.0\"N 35°32'22.1\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בצומת",
     "Resion":"צומת הירדן העמקים",
     "CityName":"טבריה",
     "Position1":"32°47'16.7\"N 35°32'15.4\"E",
     "Position2":"32°47'16.8\"N 35°32'16.1\"E",
     "Position3":"32°47'16.1\"N 35°32'16.2\"E",
     "Position4":"32°47'15.9\"N 35°32'15.5\"E"
  },
  {
     "Code":"ב",
     "Description":"נמצאו שרידי עצמות שנסחפו מתחת הכביש",
     "Area":"בין רחוב יורדי הים לרחוב ש\"י עגנון בנתיב הימני",
     "Resion":"חיל הים",
     "CityName":"אשקלון",
     "Position1":"31°39'45.0\"N 34°33'13.1\"E",
     "Position2":"31°39'48.6\"N 34°33'16.1\"E",
     "Position3":"31°39'48.5\"N 34°33'16.6\"E",
     "Position4":"31°39'44.7\"N 34°33'13.3\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מרחוב הע\"ל עד סופו",
     "Resion":"אביבית",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מרחוב ויצמן עד סופו",
     "Resion":"אחד העם",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב ביאליק לרחוב אוסישקין בחלקו",
     "Resion":"בזל [עליון]",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב ויצמן לרחוב סוקולוב",
     "Resion":"בלפור",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"משדרות דוד חכם עד סופו בקו ישר ללא העיקול",
     "Resion":"בנימין בן אסא",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"כולו",
     "Resion":"בר אילן",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מדרך חברון בקו ישר עד סופו ללא העיקול",
     "Resion":"דקל",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב אסירי ציון לשדרות זלמן שז\"ר",
     "Resion":"הגאולים",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב צבר לרחוב הע\"ל",
     "Resion":"הדר",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב ירמיהו לרחוב הפלמ\"ח",
     "Resion":"ההגנה",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין שד' שזר לשד' יצחק רג'ר",
     "Resion":"הנרייטה סולד",
     "CityName":"באר שבע",
     "Position1":"31°14'49.6\"N 34°47'52.0\"E",
     "Position2":"31°14'48.9\"N 34°47'54.5\"E",
     "Position3":"31°14'48.9\"N 34°47'59.6\"E",
     "Position4":"31°14'51.9\"N 34°48'09.8\"E",
     "Position5":"31°14'51.5\"N 34°48'10.0\"E",
     "Position6":"31°14'48.6\"N 34°48'00.6\"E",
     "Position7":"31°14'48.4\"N 34°47'59.5\"E",
     "Position8":"31°14'48.5\"N 34°47'54.3\"E",
     "Position9":"31°14'48.7\"N 34°47'52.8\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מרחוב ויצמן עד סופו",
     "Resion":"השומר",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מרחוב הנרייטה סולד עד היכל התרבות",
     "Resion":"התקוה - מדרחוב",
     "CityName":"באר שבע",
     "Position1":"31°14'53.5\"N 34°47'53.1\"E",
     "Position2":"31°14'53.4\"N 34°47'55.9\"E",
     "Position3":"31°14'53.1\"N 34°47'56.4\"E",
     "Position4":"31°14'52.2\"N 34°47'56.7\"E",
     "Position5":"31°14'49.2\"N 34°47'57.0\"E",
     "Position6":"31°14'49.2\"N 34°47'56.7\"E",
     "Position7":"31°14'52.6\"N 34°47'56.4\"E",
     "Position8":"31°14'53.2\"N 34°47'56.0\"E",
     "Position9":"31°14'53.3\"N 34°47'53.2\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב לייב יפה לרחוב קרן היסוד [מרכז אזרחי]",
     "Resion":"וולפסון",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין שד' יצחק רג'ר לכיכר שברחוב סוקולוב",
     "Resion":"ויצמן",
     "CityName":"באר שבע",
     "Position1":"31°14'56.0\"N 34°47'32.7\"E",
     "Position2":"31°14'50.9\"N 34°47'41.2\"E",
     "Position3":"31°14'49.5\"N 34°47'44.8\"E",
     "Position4":"31°14'47.6\"N 34°47'47.6\"E",
     "Position5":"31°14'47.3\"N 34°47'47.4\"E",
     "Position6":"31°14'49.1\"N 34°47'44.8\"E",
     "Position7":"31°14'50.2\"N 34°47'41.8\"E",
     "Position8":"31°14'52.4\"N 34°47'37.9\"E",
     "Position9":"31°14'55.4\"N 34°47'33.1\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב רוטשילד לרחוב בן צבי",
     "Resion":"חיים יחיל",
     "CityName":"באר שבע",
     "Position1":"31°14'38.8\"N 34°48'01.8\"E",
     "Position2":"31°14'38.8\"N 34°48'07.5\"E",
     "Position3":"31°14'38.4\"N 34°48'10.5\"E",
     "Position4":"31°14'37.5\"N 34°48'10.2\"E",
     "Position5":"31°14'38.2\"N 34°48'07.5\"E",
     "Position6":"31°14'38.2\"N 34°48'01.1\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב חיים יחיל לשד' יצחק רג'ר",
     "Resion":"יצחק בן צבי",
     "CityName":"באר שבע",
     "Position1":"31°14'41.0\"N 34°47'44.1\"E",
     "Position2":"31°14'40.5\"N 34°47'44.6\"E",
     "Position3":"31°14'39.0\"N 34°47'47.6\"E",
     "Position4":"31°14'38.9\"N 34°47'53.5\"E",
     "Position5":"31°14'38.1\"N 34°47'53.6\"E",
     "Position6":"31°14'38.5\"N 34°47'47.6\"E",
     "Position7":"31°14'38.9\"N 34°47'46.4\"E",
     "Position8":"31°14'40.5\"N 34°47'43.6\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב מקס בינט לשד' שזר",
     "Resion":"לאונרד כהן [אלקלעי]",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מרחוב הנרייטה סולד עד הסוף בקו ישר",
     "Resion":"לייב יפה",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מרחוב ויצמן עד סופו",
     "Resion":"מנדלי מוכר ספרים",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מצומת הרחובות שד' זלמן שזר - דרך השלום עד כיכר מנחם בגין",
     "Resion":"מנחם בגין",
     "CityName":"באר שבע"
  },
  {
     "Code":"ב",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"משד' זלמן שזר עד סופו",
     "Resion":"מנחם קרויצר",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב חיים יחיל לדרך חברון",
     "Resion":"מקס נורדאו",
     "CityName":"באר שבע",
     "Position1":"31°14'26.7\"N 34°48'01.5\"E",
     "Position2":"31°14'30.1\"N 34°47'58.0\"E",
     "Position3":"31°14'38.2\"N 34°47'57.9\"E",
     "Position4":"31°14'38.0\"N 34°47'58.8\"E",
     "Position5":"31°14'33.8\"N 34°47'59.0\"E",
     "Position6":"31°14'31.4\"N 34°47'58.7\"E",
     "Position7":"31°14'29.3\"N 34°47'59.4\"E",
     "Position8":"31°14'27.9\"N 34°48'00.8\"E",
     "Position9":"31°14'27.2\"N 34°48'02.2\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מרחוב שמריהו לוין עד סופו",
     "Resion":"נהריים",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב ויצמן לשד' יצחק טוביהו",
     "Resion":"סוקולוב",
     "CityName":"באר שבע",
     "Position1":"31°14'43.0\"N 34°47'20.9\"E",
     "Position2":"31°14'48.2\"N 34°47'23.7\"E",
     "Position3":"31°14'51.3\"N 34°47'25.4\"E",
     "Position4":"31°14'51.9\"N 34°47'26.4\"E",
     "Position5":"31°14'53.9\"N 34°47'31.0\"E",
     "Position6":"31°14'56.0\"N 34°47'32.3\"E",
     "Position7":"31°14'55.5\"N 34°47'33.1\"E",
     "Position8":"31°14'55.3\"N 34°47'32.6\"E",
     "Position9":"31°14'53.6\"N 34°47'31.4\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב צבר לרחוב הע\"ל",
     "Resion":"פקועה",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב חבצלת הנגב לרחוב אירוס הנגב",
     "Resion":"צבר",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב חיים יחיל לרחוב הנרייטה סולד",
     "Resion":"קרן היסוד",
     "CityName":"באר שבע",
     "Position1":"31°14'48.4\"N 34°48'00.5\"E",
     "Position2":"31°14'46.9\"N 34°48'00.6\"E",
     "Position3":"31°14'44.4\"N 34°48'00.6\"E",
     "Position4":"31°14'39.2\"N 34°48'00.6\"E",
     "Position5":"31°14'39.3\"N 34°47'60.0\"E",
     "Position6":"31°14'42.3\"N 34°47'59.8\"E",
     "Position7":"31°14'44.3\"N 34°47'59.7\"E",
     "Position8":"31°14'48.1\"N 34°47'59.9\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין שד' שזר לדרך חברון",
     "Resion":"רוטשילד",
     "CityName":"באר שבע",
     "Position1":"31°14'27.0\"N 34°48'03.0\"E",
     "Position2":"31°14'37.1\"N 34°48'10.2\"E",
     "Position3":"31°14'42.2\"N 34°48'16.5\"E",
     "Position4":"31°14'40.8\"N 34°48'17.0\"E",
     "Position5":"31°14'36.6\"N 34°48'11.7\"E",
     "Position6":"31°14'28.7\"N 34°48'06.5\"E",
     "Position7":"31°14'26.5\"N 34°48'04.4\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב הע\"ל לרחוב צבר",
     "Resion":"רותם",
     "CityName":"באר שבע"
  },
  {
     "Code":"ב",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"משד' זלמן שזר עד סופו",
     "Resion":"רחה פריאר",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין דרך חברון לשד' יצחק רג'ר",
     "Resion":"שד' זלמן שזר",
     "CityName":"באר שבע",
     "Position1":"31°15'03.6\"N 34°47'55.2\"E",
     "Position2":"31°15'01.2\"N 34°48'02.6\"E",
     "Position3":"31°14'53.4\"N 34°48'10.4\"E",
     "Position4":"31°14'48.6\"N 34°48'14.7\"E",
     "Position5":"31°14'42.1\"N 34°48'18.4\"E",
     "Position6":"31°14'40.4\"N 34°48'22.0\"E",
     "Position7":"31°14'39.2\"N 34°48'21.4\"E",
     "Position8":"31°14'40.0\"N 34°48'19.2\"E",
     "Position9":"31°14'42.7\"N 34°48'16.2\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין צומת אלי כהן [שד' דוד חכם - שד' דוד טוביהו] לרחוב בן צבי",
     "Resion":"שד' יצחק רגר",
     "CityName":"באר שבע",
     "Position1":"31°14'38.6\"N 34°47'36.1\"E",
     "Position2":"31°14'42.1\"N 34°47'43.4\"E",
     "Position3":"31°14'41.0\"N 34°47'44.0\"E",
     "Position4":"31°14'39.6\"N 34°47'41.4\"E",
     "Position5":"31°14'37.9\"N 34°47'37.3\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"כולו -בין החיבור הראשון לבלפור לחיבור השני לבלפור",
     "Resion":"שח\"ל",
     "CityName":"באר שבע"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין שד' דוד חכם לרחוב וולפסון",
     "Resion":"שמריהו לוין",
     "CityName":"באר שבע",
     "Position1":"31°14'39.1\"N 34°47'47.7\"E",
     "Position2":"31°14'44.9\"N 34°47'51.6\"E",
     "Position3":"31°14'44.8\"N 34°47'52.0\"E",
     "Position4":"31°14'42.6\"N 34°47'50.6\"E",
     "Position5":"31°14'42.3\"N 34°47'50.8\"E",
     "Position6":"31°14'39.0\"N 34°47'48.4\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב כפר הדרום לרחוב אצ\"ג",
     "Resion":"ההסתדרות",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב כפר הדרום לכביש 25 צומת אלי כהן",
     "Resion":"החלוץ",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב עלי דוויס לדרך חברון",
     "Resion":"העצמאות",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין צומת הרחובות הרצפלד אברהם - יצחק שדה לשד' נפתלי הירץ אימבר",
     "Resion":"הפלמ\"ח",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב כפר הדרום לכביש 25 צומת אלי כהן",
     "Resion":"הרצל",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב ירמיהו לרחוב העצמאות",
     "Resion":"חטיבת הנגב",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב כפר הדרום לרחוב אצ\"ג",
     "Resion":"מורדי הגטאות",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רח' יצחק שדה לרחוב הרצל",
     "Resion":"נגבה",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"מהכיכר של רחוב עלי דוויס עד לדרך חברון",
     "Resion":"רמב\"ם",
     "CityName":"באר שבע - כניסה לעיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב גד ליד קופת חולים כללית לצומת הרחובות חטיבת הנגב - ירמיהו",
     "Resion":"אפרים",
     "CityName":"באר שבע - מקיף העיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב הנגרים לרחוב הע\"ל",
     "Resion":"דרך חברון",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'14.4\"N 34°47'32.6\"E",
     "Position2":"31°14'16.4\"N 34°47'36.1\"E",
     "Position3":"31°14'21.6\"N 34°47'51.3\"E",
     "Position4":"31°14'24.1\"N 34°47'58.7\"E",
     "Position5":"31°14'26.8\"N 34°48'02.9\"E",
     "Position6":"31°14'26.5\"N 34°48'05.4\"E",
     "Position7":"31°14'32.7\"N 34°48'19.9\"E",
     "Position8":"31°14'36.8\"N 34°48'21.0\"E",
     "Position9":"31°14'36.5\"N 34°48'21.9\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב העצמאות לרחוב הפלמ\"ח",
     "Resion":"הרצפלד",
     "CityName":"באר שבע - מקיף העיר העתיקה"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על  קברים ספק ישראל",
     "Area":"בין אפיקים בנגב לבין חברון ואימבר",
     "Resion":"הע\"ל",
     "CityName":"באר שבע -",
     "Position1":"31°14'04.0\"N 34°47'41.1\"E",
     "Position2":"31°13'46.2\"N 34°47'53.7\"E",
     "Position3":"31°13'45.2\"N 34°47'52.7\"E",
     "Position4":"31°14'12.8\"N 34°47'33.9\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב הפלמ\"ח לרחוב ברק",
     "Resion":"יצחק שדה",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'28.3\"N 34°46'54.7\"E",
     "Position2":"31°14'37.7\"N 34°47'03.3\"E",
     "Position3":"31°14'37.3\"N 34°47'03.7\"E",
     "Position4":"31°14'28.1\"N 34°46'54.9\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב ההגנה לרחוב חטיבת הנגב",
     "Resion":"ירמיהו",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'16.8\"N 34°47'07.5\"E",
     "Position2":"31°14'15.6\"N 34°47'05.3\"E",
     "Position3":"31°14'20.1\"N 34°47'02.3\"E",
     "Position4":"31°14'22.7\"N 34°46'59.5\"E",
     "Position5":"31°14'28.1\"N 34°46'54.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין רחוב טרומפלדור צמוד לנפתלי הירץ אימבר לרחוב ההגנה",
     "Resion":"כפר דרום",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'16.8\"N 34°47'07.4\"E",
     "Position2":"31°14'09.1\"N 34°47'18.9\"E",
     "Position3":"31°14'08.5\"N 34°47'18.7\"E",
     "Position4":"31°14'16.5\"N 34°47'07.2\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין שד' טוביהו לרחוב העצמאות",
     "Resion":"עלי דוויס",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'38.8\"N 34°47'03.6\"E",
     "Position2":"31°14'44.1\"N 34°47'09.6\"E",
     "Position3":"31°14'43.7\"N 34°47'11.1\"E",
     "Position4":"31°14'38.3\"N 34°47'04.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין דרך חברון לצומת הרחובות שד' טוביהו - שד' יצחק רג'ר",
     "Resion":"שד' דוד חכם",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'38.9\"N 34°47'35.7\"E",
     "Position2":"31°14'32.3\"N 34°47'45.0\"E",
     "Position3":"31°14'28.9\"N 34°47'48.7\"E",
     "Position4":"31°14'25.7\"N 34°47'50.9\"E",
     "Position5":"31°14'21.0\"N 34°47'53.0\"E",
     "Position6":"31°14'20.5\"N 34°47'51.7\"E",
     "Position7":"31°14'27.5\"N 34°47'48.0\"E",
     "Position8":"31°14'31.1\"N 34°47'44.1\"E",
     "Position9":"31°14'37.8\"N 34°47'35.5\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין צומת הרחובות שד' דוד חכם - שד' יצחק רג'ר לרחוב דרך המשחררים",
     "Resion":"שד' דוד טוביהו",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'47.6\"N 34°46'58.3\"E",
     "Position2":"31°14'40.9\"N 34°47'30.9\"E",
     "Position3":"31°14'38.8\"N 34°47'35.9\"E",
     "Position4":"31°14'37.9\"N 34°47'35.2\"E",
     "Position5":"31°14'40.4\"N 34°47'26.7\"E",
     "Position6":"31°14'46.5\"N 34°46'57.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים ספק ישראל",
     "Area":"בין צומת הרחובות דרך חברון - הע\"ל לכיכר קק\"ל מול כפר דרום",
     "Resion":"שד' נפתלי הירץ אימבר",
     "CityName":"באר שבע - מקיף העיר העתיקה",
     "Position1":"31°14'07.8\"N 34°47'18.6\"E",
     "Position2":"31°14'14.4\"N 34°47'32.2\"E",
     "Position3":"31°14'13.2\"N 34°47'33.1\"E",
     "Position4":"31°14'09.3\"N 34°47'26.1\"E",
     "Position5":"31°14'06.8\"N 34°47'19.4\"E"
  },
  {
     "Code":"ב",
     "Description":"יש עצים שמאהילים על הכביש מקברי גויים",
     "Area":"בין מחלף לטרון לפארק קנדה בנתיב הימני לכיוון צפון",
     "Resion":"כביש 3",
     "CityName":"בינעירוני",
     "Position1":"31°50'21.6\"N 34°59'17.6\"E",
     "Position2":"31°50'24.5\"N 34°59'24.8\"E",
     "Position3":"31°50'24.3\"N 34°59'24.8\"E",
     "Position4":"31°50'21.4\"N 34°59'17.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין צומת מודיעים לגשר היוצא מכביש 443 בנתיב הפונה לחדיד והנתיב הצמוד לו לכיוון צפון",
     "Resion":"כביש 444",
     "CityName":"בינעירוני",
     "Position1":"31°57'16.5\"N 34°56'22.9\"E",
     "Position2":"31°57'24.4\"N 34°56'29.0\"E",
     "Position3":"31°57'28.7\"N 34°56'31.0\"E",
     "Position4":"31°57'28.2\"N 34°56'31.5\"E",
     "Position5":"31°57'22.4\"N 34°56'28.4\"E",
     "Position6":"31°57'16.9\"N 34°56'24.3\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין מחלף קדרים לצומת נחל צלמון בסמוך לקבר חבקוק הנביא",
     "Resion":"כביש 65",
     "CityName":"בינעירוני",
     "Position1":"32°53'19.3\"N 35°28'44.9\"E",
     "Position2":"32°53'23.3\"N 35°28'46.8\"E",
     "Position3":"32°53'26.4\"N 35°28'47.3\"E",
     "Position4":"32°53'26.5\"N 35°28'48.4\"E",
     "Position5":"32°53'22.5\"N 35°28'47.7\"E",
     "Position6":"32°53'19.2\"N 35°28'46.1\"E"
  },
  {
     "Code":"א",
     "Description":"עצים מאהילים על קברים ועל הכביש",
     "Area":"כביש הגישה לנחל השופט, במקום הסמוך לבית קברות הזורע",
     "Resion":"כביש הגישה לחניון החרובים",
     "CityName":"בינעירוני",
     "Position1":"32°38'25.9\"N 35°06'52.2\"E",
     "Position2":"32°38'23.5\"N 35°06'50.3\"E",
     "Position3":"32°38'22.9\"N 35°06'49.6\"E",
     "Position4":"32°38'22.6\"N 35°06'49.1\"E",
     "Position5":"32°38'22.8\"N 35°06'49.0\"E",
     "Position6":"32°38'23.2\"N 35°06'49.6\"E",
     "Position7":"32°38'26.0\"N 35°06'52.1\"E"
  },
  {
     "Code":"א",
     "Description":"יש עצים שמאהילים על הכביש מקברי ישראל",
     "Area":"בין כביש 8655 לכיכר הכניסה לפקיעין החדשה בנתיב הימני לבאים ממעלות",
     "Resion":"כביש 864",
     "CityName":"בינעירוני",
     "Position1":"32°59'13.6\"N 35°19'28.4\"E",
     "Position2":"32°59'13.8\"N 35°19'28.8\"E",
     "Position3":"32°59'12.4\"N 35°19'29.6\"E",
     "Position4":"32°59'12.2\"N 35°19'29.1\"E"
  },
  {
     "Code":"ב",
     "Description":"המחיצות העשויות מצורת הפתח נוטות ליפול",
     "Area":"כביש הכניסה לבית החיים פוניבז'",
     "Resion":"חזון איש",
     "CityName":"בני ברק"
  },
  {
     "Code":"א",
     "Description":"יש עצים שמאהילים על הכביש מקברי ישראל",
     "Area":"בין רחוב גלוסקא לרחוב עליית הנוער",
     "Resion":"אבני זיכרון",
     "CityName":"גבעתיים",
     "Position1":"32°04'22.1\"N 34°48'02.8\"E",
     "Position2":"32°04'18.4\"N 34°48'05.7\"E",
     "Position3":"32°04'15.0\"N 34°48'08.4\"E",
     "Position4":"32°04'14.7\"N 34°48'08.2\"E",
     "Position5":"32°04'16.8\"N 34°48'06.3\"E",
     "Position6":"32°04'21.8\"N 34°48'02.7\"E"
  },
  {
     "Code":"ב",
     "Description":"לפעמים יש עצים שמאהילים על הכביש מקברי ישראל",
     "Area":"בסיבוב ימינה לרחוב עליית הנוער בנתיב הימני",
     "Resion":"דרך השלום",
     "CityName":"גבעתיים",
     "Position1":"32°04'17.4\"N 34°48'00.9\"E",
     "Position2":"32°04'15.5\"N 34°48'00.2\"E",
     "Position3":"32°04'14.8\"N 34°48'01.3\"E",
     "Position4":"32°04'14.4\"N 34°48'01.2\"E",
     "Position5":"32°04'15.2\"N 34°47'59.7\"E",
     "Position6":"32°04'17.2\"N 34°48'00.3\"E"
  },
  {
     "Code":"ב",
     "Description":"לפעמים יש עצים שמאהילים על הכביש מקברי ישראל",
     "Area":"בין רחוב טייבר לרחוב הל\"ה בנתיב הצמוד לבית הקברות",
     "Resion":"ויצמן",
     "CityName":"גבעתיים",
     "Position1":"32°04'22.9\"N 34°48'31.0\"E",
     "Position2":"32°04'18.7\"N 34°48'31.0\"E",
     "Position3":"32°04'18.7\"N 34°48'30.7\"E",
     "Position4":"32°04'22.9\"N 34°48'30.7\"E"
  },
  {
     "Code":"א",
     "Description":"יש עצים שמאהילים על הכביש מקברי ישראל",
     "Area":"בין רחוב אבני זיכרון לרחוב ויצמן",
     "Resion":"טייבר",
     "CityName":"גבעתיים",
     "Position1":"32°04'17.0\"N 34°48'06.5\"E",
     "Position2":"32°04'18.1\"N 34°48'19.1\"E",
     "Position3":"32°04'19.0\"N 34°48'30.7\"E",
     "Position4":"32°04'18.7\"N 34°48'30.7\"E",
     "Position5":"32°04'17.7\"N 34°48'18.9\"E",
     "Position6":"32°04'16.7\"N 34°48'06.8\"E"
  },
  {
     "Code":"ב",
     "Description":"יש עצים שמאהילים על הכביש מקברי גויים",
     "Area":"בין רחוב סיליזיאן לרחוב הבנקים בנתיב הנסיעה הימני לכיוון צפון",
     "Resion":"דרך העצמאות",
     "CityName":"חיפה",
     "Position1":"32°49'17.4\"N 34°59'46.5\"E",
     "Position2":"32°49'16.6\"N 34°59'47.6\"E",
     "Position3":"32°49'16.3\"N 34°59'47.3\"E",
     "Position4":"32°49'17.0\"N 34°59'46.4\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש סלול על קברי גויים",
     "Area":"לפני הכניסה הדרומית למנהרות הכרמל במקביל לרחוב צביה ויצחק",
     "Resion":"כביש 23",
     "CityName":"חיפה",
     "Position1":"32°47'34.3\"N 34°58'02.9\"E",
     "Position2":"32°47'33.9\"N 34°58'08.5\"E",
     "Position3":"32°47'31.9\"N 34°58'08.5\"E",
     "Position4":"32°47'32.4\"N 34°58'03.2\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברים",
     "Area":"בין רחוב המשטרה לרחוב דוגית בנתיב הנסיעה לכיוון דרום",
     "Resion":"מסילת הברזל",
     "CityName":"חיפה",
     "Position1":"32°49'36.3\"N 34°59'20.1\"E",
     "Position2":"32°49'31.2\"N 34°59'26.8\"E",
     "Position3":"32°49'30.8\"N 34°59'26.6\"E",
     "Position4":"32°49'35.3\"N 34°59'20.7\"E"
  },
  {
     "Code":"ב",
     "Description":"יש עצים שמאהילים על הכביש מקברי גויים",
     "Area":"בין רחוב יצחק קריב לרחוב קרן היסוד בנתיב הימני לבאים מממילא",
     "Resion":"אגרון",
     "CityName":"ירושלים",
     "Position1":"31°46'40.4\"N 35°13'19.7\"E",
     "Position2":"31°46'40.0\"N 35°13'19.4\"E",
     "Position3":"31°46'37.1\"N 35°13'13.3\"E",
     "Position4":"31°46'37.3\"N 35°13'13.2\"E",
     "Position5":"31°46'40.4\"N 35°13'19.4\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב דרך יריחו לרחוב מעלה השלום בחלקו",
     "Resion":"דרך העופל",
     "CityName":"ירושלים",
     "Position1":"31°46'30.0\"N 35°14'12.0\"E",
     "Position2":"31°46'34.5\"N 35°14'15.9\"E",
     "Position3":"31°46'42.2\"N 35°14'16.4\"E",
     "Position4":"31°46'43.4\"N 35°14'16.0\"E",
     "Position5":"31°46'48.6\"N 35°14'15.8\"E",
     "Position6":"31°46'49.6\"N 35°14'18.2\"E",
     "Position7":"31°46'49.3\"N 35°14'18.3\"E",
     "Position8":"31°46'48.5\"N 35°14'16.2\"E",
     "Position9":"31°46'42.3\"N 35°14'16.7\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב אל מנסוריה לרחוב דוואר אל נח'יל",
     "Resion":"דרך יריחו",
     "CityName":"ירושלים",
     "Position1":"31°46'43.1\"N 35°14'23.3\"E",
     "Position2":"31°46'40.7\"N 35°14'24.2\"E",
     "Position3":"31°46'33.4\"N 35°14'25.8\"E",
     "Position4":"31°46'26.7\"N 35°14'26.1\"E",
     "Position5":"31°46'26.8\"N 35°14'25.4\"E",
     "Position6":"31°46'33.5\"N 35°14'24.9\"E",
     "Position7":"31°46'40.1\"N 35°14'23.5\"E",
     "Position8":"31°46'43.2\"N 35°14'22.2\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב פייר ואן פאסן לכיכר שברחוב שמעון הצדיק",
     "Resion":"דרך שכם",
     "CityName":"ירושלים",
     "Position1":"31°47'27.2\"N 35°13'43.4\"E",
     "Position2":"31°47'29.3\"N 35°13'43.1\"E",
     "Position3":"31°47'32.8\"N 35°13'44.4\"E",
     "Position4":"31°47'32.7\"N 35°13'44.9\"E",
     "Position5":"31°47'29.6\"N 35°13'43.7\"E",
     "Position6":"31°47'28.2\"N 35°13'43.7\"E",
     "Position7":"31°47'27.2\"N 35°13'43.9\"E"
  },
  {
     "Code":"ג",
     "Description":"מערת קבורה הממשיכה כנראה תחת הכביש",
     "Area":"באיזור מגרש החניה",
     "Resion":"הר הזידים",
     "CityName":"ירושלים",
     "Position1":"31°46'42.4\"N 35°14'38.0\"E",
     "Position2":"31°46'42.6\"N 35°14'39.3\"E",
     "Position3":"31°46'42.1\"N 35°14'39.5\"E",
     "Position4":"31°46'41.9\"N 35°14'38.2\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין תחנת המשטרה בהר הזיתים לבניין שבע הקשתות",
     "Resion":"הר המשחה",
     "CityName":"ירושלים",
     "Position1":"31°46'34.4\"N 35°14'35.2\"E",
     "Position2":"31°46'33.6\"N 35°14'34.3\"E",
     "Position3":"31°46'34.2\"N 35°14'34.5\"E",
     "Position4":"31°46'34.7\"N 35°14'35.4\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"כולו",
     "Resion":"חניון הר הזיתים",
     "CityName":"ירושלים",
     "Position1":"31°46'26.8\"N 35°14'29.3\"E",
     "Position2":"31°46'26.8\"N 35°14'30.1\"E",
     "Position3":"31°46'24.8\"N 35°14'30.2\"E",
     "Position4":"31°46'24.8\"N 35°14'29.1\"E"
  },
  {
     "Code":"ב",
     "Description":"יש עצים שמאהילים על הכביש מקברי גויים",
     "Area":"בין רחוב מישאל לרחוב מלל בנתיב הימני לבאים מכיוון רחוב מישאל",
     "Resion":"עמק רפאים",
     "CityName":"ירושלים",
     "Position1":"31°45'48.0\"N 35°13'09.3\"E",
     "Position2":"31°45'46.0\"N 35°13'06.9\"E",
     "Position3":"31°45'46.2\"N 35°13'06.8\"E",
     "Position4":"31°45'48.1\"N 35°13'09.1\"E"
  },
  {
     "Code":"ג",
     "Description":"יש עצים שמאהילים על הכביש מקברי גויים",
     "Area":"בין רחוב נחושתן אורי לכיכר העצמאות - החשמונאים בנתיב הצמוד לבית הקברות",
     "Resion":"הנרייטה סולד",
     "CityName":"לוד",
     "Position1":"31°56'59.7\"N 34°53'45.3\"E",
     "Position2":"31°56'54.3\"N 34°53'39.3\"E",
     "Position3":"31°56'54.6\"N 34°53'39.0\"E",
     "Position4":"31°56'57.7\"N 34°53'41.9\"E",
     "Position5":"31°56'59.2\"N 34°53'43.8\"E",
     "Position6":"31°56'59.9\"N 34°53'45.5\"E"
  },
  {
     "Code":"ב",
     "Description":"יש עצים שמאהילים על הכביש מקברי ישראל",
     "Area":"בין רחוב סוקולוב לרחוב גולומב בנתיב הצמוד לבית הקברות",
     "Resion":"כצנלסון",
     "CityName":"לוד",
     "Position1":"31°57'24.2\"N 34°53'43.0\"E",
     "Position2":"31°57'24.2\"N 34°53'43.3\"E",
     "Position3":"31°57'22.3\"N 34°53'42.6\"E",
     "Position4":"31°57'22.3\"N 34°53'42.4\"E"
  },
  {
     "Code":"ב",
     "Area":"חשש לקברים",
     "Resion":"מחוץ לציון רשב\"י",
     "CityName":"מירון",
     "Position1":"32°58'52.9\"N 35°26'26.8\"E",
     "Position2":"32°58'52.9\"N 35°26'27.0\"E",
     "Position3":"32°58'52.0\"N 35°26'27.5\"E",
     "Position4":"32°58'51.9\"N 35°26'27.3\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"כולו",
     "Resion":"הכביש היוצא מסוף רחוב בר יוחאי לכיוון ציון הרשב\"י",
     "CityName":"מירון",
     "Position1":"32°58'53.1\"N 35°26'31.2\"E",
     "Position2":"32°58'51.0\"N 35°26'29.3\"E",
     "Position3":"32°58'48.9\"N 35°26'23.9\"E",
     "Position4":"32°58'49.2\"N 35°26'23.8\"E",
     "Position5":"32°58'50.7\"N 35°26'28.1\"E",
     "Position6":"32°58'51.3\"N 35°26'29.3\"E",
     "Position7":"32°58'52.7\"N 35°26'30.1\"E",
     "Position8":"32°58'53.3\"N 35°26'30.8\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"בין רחוב בר יוחאי עד אחרי ציון הרשב\"י בשני הנתיבים",
     "Resion":"מעלה הרשבי - כביש 8599",
     "CityName":"מירון",
     "Position1":"32°58'53.7\"N 35°26'27.7\"E",
     "Position2":"32°58'53.2\"N 35°26'27.1\"E",
     "Position3":"32°58'52.0\"N 35°26'21.4\"E",
     "Position4":"32°58'52.3\"N 35°26'21.4\"E",
     "Position5":"32°58'52.8\"N 35°26'25.1\"E",
     "Position6":"32°58'53.5\"N 35°26'26.4\"E",
     "Position7":"32°58'53.8\"N 35°26'27.4\"E"
  },
  {
     "Code":"ב",
     "Description":"קברי עכו\"ם במערב הרחוב, עצים מאהילים על נתיב הנסיעה",
     "Area":"הנתיב לכיוון חוף הים",
     "Resion":"יהושפט",
     "CityName":"עכו",
     "Position1":"32°55'22.0\"N 35°04'30.8\"E",
     "Position2":"32°55'23.8\"N 35°04'31.6\"E",
     "Position3":"32°55'23.8\"N 35°04'31.7\"E",
     "Position4":"32°55'21.8\"N 35°04'30.9\"E"
  },
  {
     "Code":"ב",
     "Description":"יש עצים שלפעמים מאהילים על הכביש מקברי גויים",
     "Area":"הנתיב הימני לכיוון צפון של הכיכר שבין רחוב יונתן החשמונאי לרחוב דרך הארבעה",
     "Resion":"יונתן החשמונאי",
     "CityName":"עכו",
     "Position1":"32°55'16.0\"N 35°04'36.7\"E",
     "Position2":"32°55'15.4\"N 35°04'37.0\"E",
     "Position3":"32°55'15.3\"N 35°04'36.6\"E",
     "Position4":"32°55'16.0\"N 35°04'36.4\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש בסבירות גבוהה נסלל על קברים",
     "Area":"בעיקול שסמוך לרחוב רואי אליעזר",
     "Resion":"מייזנר",
     "CityName":"פתח תקווה",
     "Position1":"32°04'40.2\"N 34°52'07.8\"E",
     "Position2":"32°04'39.8\"N 34°52'08.1\"E",
     "Position3":"32°04'39.6\"N 34°52'07.8\"E",
     "Position4":"32°04'39.9\"N 34°52'07.5\"E"
  },
  {
     "Code":"ג",
     "Description":"הכביש ספק סלול על קברי גויים",
     "Area":"כולו",
     "Resion":"הכביש שבין רחוב העצמאות לבריכת השחיה ולפארק עמק התכלת",
     "CityName":"צפת",
     "Position1":"32°58'17.4\"N 35°29'55.4\"E",
     "Position2":"32°58'20.1\"N 35°29'58.1\"E",
     "Position3":"32°58'21.4\"N 35°30'00.5\"E",
     "Position4":"32°58'23.2\"N 35°30'06.7\"E",
     "Position5":"32°58'23.0\"N 35°30'06.8\"E",
     "Position6":"32°58'21.0\"N 35°30'00.5\"E",
     "Position7":"32°58'19.6\"N 35°29'57.9\"E",
     "Position8":"32°58'17.7\"N 35°29'56.0\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש ספק סלול על קברי גויים",
     "Area":"כולו",
     "Resion":"כביש הכניסה לחניונים היוצאים מרחוב הפלמ\"ח למרכז תרבות יגאל אלון וביטח לאומי ולסראיה",
     "CityName":"צפת",
     "Position1":"32°57'51.6\"N 35°29'46.0\"E",
     "Position2":"32°57'52.4\"N 35°29'50.8\"E",
     "Position3":"32°57'51.5\"N 35°29'51.3\"E",
     "Position4":"32°57'50.7\"N 35°29'47.3\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש ספק נסלל על קברים",
     "Area":"כולו",
     "Resion":"שביל העפר שבין רחוב האר\"י לטיילת היורדת לרחוב צה\"ל",
     "CityName":"צפת",
     "Position1":"32°58'04.0\"N 35°29'27.8\"E",
     "Position2":"32°58'02.8\"N 35°29'29.3\"E",
     "Position3":"32°58'02.1\"N 35°29'29.6\"E",
     "Position4":"32°58'01.2\"N 35°29'29.4\"E",
     "Position5":"32°58'00.7\"N 35°29'28.5\"E",
     "Position6":"32°58'00.5\"N 35°29'27.4\"E",
     "Position7":"32°58'00.7\"N 35°29'27.5\"E",
     "Position8":"32°58'00.9\"N 35°29'28.5\"E",
     "Position9":"32°58'01.6\"N 35°29'29.2\"E"
  },
  {
     "Code":"ב",
     "Description":"הכביש עובר במערה מתחת קברים",
     "Area":"בין רחוב חיים וייצמן לרחוב יהודה הלוי",
     "Resion":"שדרות בן גוריון",
     "CityName":"ראש העין",
     "Position1":"32°05'06.9\"N 34°57'33.3\"E",
     "Position2":"32°05'05.8\"N 34°57'36.0\"E",
     "Position3":"32°05'04.2\"N 34°57'37.4\"E",
     "Position4":"32°05'03.6\"N 34°57'36.4\"E",
     "Position5":"32°05'05.0\"N 34°57'35.0\"E",
     "Position6":"32°05'05.7\"N 34°57'33.5\"E"
  },
  {
     "Code":"ב",
     "Description":"יש עצים שמאהילים על הכביש מקברי גויים",
     "Area":"בין רחוב חנה סנש לרחוב מרכוס בנתיב הימני לבאים מרחוב חנה סנש",
     "Resion":"שדרות הרצל",
     "CityName":"רמלה",
     "Position1":"31°55'46.2\"N 34°52'14.2\"E",
     "Position2":"31°55'43.5\"N 34°52'16.6\"E",
     "Position3":"31°55'43.3\"N 34°52'16.3\"E",
     "Position4":"31°55'44.7\"N 34°52'15.0\"E",
     "Position5":"31°55'46.1\"N 34°52'13.9\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש עוברת תחת גשרים המחוברים לבית החולים",
     "Area":"בין בניין התפתחות הילד לבניין המעבדות",
     "Resion":"כביש בית החולים שיבא - תל השומר",
     "CityName":"רמת גן",
     "Position1":"32°02'52.9\"N 34°50'33.6\"E",
     "Position2":"32°02'52.9\"N 34°50'35.9\"E",
     "Position3":"32°02'52.3\"N 34°50'36.3\"E",
     "Position4":"32°02'52.0\"N 34°50'35.3\"E",
     "Position5":"32°02'52.7\"N 34°50'34.5\"E",
     "Position6":"32°02'52.7\"N 34°50'33.5\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש נסלל על קברי ישראל",
     "Area":"בין רחוב עולי הרגל לרחוב מעלה הקטורת",
     "Resion":"גורל הנחלות",
     "CityName":"שילה",
     "Position1":"32°03'07.7\"N 35°17'30.5\"E",
     "Position2":"32°03'10.1\"N 35°17'35.3\"E",
     "Position3":"32°03'10.7\"N 35°17'37.2\"E",
     "Position4":"32°03'10.3\"N 35°17'37.5\"E",
     "Position5":"32°03'07.6\"N 35°17'31.2\"E",
     "Position6":"32°03'07.4\"N 35°17'30.4\"E"
  },
  {
     "Code":"א",
     "Description":"יש עצים שמאהילים על הכביש מבית החולים",
     "Area":"בין רחוב וייצמן לרחוב הנרייטה סולד",
     "Resion":"דפנה",
     "CityName":"תל אביב",
     "Position1":"32°04'42.6\"N 34°47'18.9\"E",
     "Position2":"32°04'42.5\"N 34°47'24.5\"E",
     "Position3":"32°04'42.9\"N 34°47'28.3\"E",
     "Position4":"32°04'42.6\"N 34°47'28.3\"E",
     "Position5":"32°04'42.3\"N 34°47'25.9\"E",
     "Position6":"32°04'42.3\"N 34°47'18.9\"E"
  },
  {
     "Code":"א",
     "Description":"הכביש עובר תחת גשר המחבר בין בנייני בית החולים",
     "Area":"כשנכנסים מרחוב ויצמן",
     "Resion":"כביש הכניסה לבית החולים איכילוב",
     "CityName":"תל אביב",
     "Position1":"32°04'52.2\"N 34°47'20.3\"E",
     "Position2":"32°04'52.2\"N 34°47'21.4\"E",
     "Position3":"32°04'52.0\"N 34°47'21.4\"E",
     "Position4":"32°04'51.9\"N 34°47'20.3\"E"
  },
  {
     "Code":"א",
     "Description":"עצי אורן צפופים מאהילים על קברים",
     "Resion":"כניסה לבית הקברות למעלה",
     "CityName":"חצור",
     "Position1":"32°58'45.6\"N 35°32'06.7\"E",
     "Position2":"32°58'43.6\"N 35°32'06.8\"E",
     "Position3":"32°58'43.6\"N 35°32'06.4\"E",
     "Position4":"32°58'45.6\"N 35°32'06.2\"E"
  }
]


// [
//   {
//     "Code": "א",
//     "Position1": "32°47'31.0\"N 35°32'10.7\"E",
//     "Position2": "32°47'26.5\"N 35°32'20.9\"E",
//     "Position3": "32°47'23.6\"N 35°32'23.4\"E",
//     "Position4": "32°47'18.2\"N 35°32'25.5\"E",
//     "Position5": "32°47'18.1\"N 35°32'24.7\"E",
//     "Position6": "32°47'23.2\"N 35°32'22.9\"E",
//     "Position7": "32°47'25.9\"N 35°32'20.6\"E",
//     "Position8": "32°47'28.3\"N 35°32'14.1\"E",
//     "Position9": "32°47'30.4\"N 35°32'10.2\"E"
//   },
//   {
//     "Code": "א",
//     "Position1": "32°47'31.0\"N 35°32'14.1\"E",
//     "Position2": "32°47'32.7\"N 35°32'21.0\"E",
//     "Position3": "32°47'35.6\"N 35°32'23.3\"E",
//     "Position4": "32°47'35.1\"N 35°32'23.5\"E",
//     "Position5": "32°47'32.4\"N 35°32'21.3\"E",
//     "Position6": "32°47'30.7\"N 35°32'14.3\"E"
//   },
//   {
//     "Code": "א",
//     "Position1": "32°47'17.3\"N 35°32'25.0\"E",
//     "Position2": "32°47'17.4\"N 35°32'25.8\"E",
//     "Position3": "32°47'13.6\"N 35°32'27.3\"E",
//     "Position4": "32°47'13.4\"N 35°32'26.8\"E"
//   },
//   {
//     "Code": "א",
//     "Position1": "32°47'17.2\"N 35°32'22.1\"E",
//     "Position2": "32°47'17.8\"N 35°32'21.9\"E",
//     "Position3": "32°47'18.8\"N 35°32'29.7\"E",
//     "Position4": "32°47'18.3\"N 35°32'29.8\"E"
//   },
//   {
//     "Code": "א",
//     "Position1": "32°47'16.7\"N 35°32'15.4\"E",
//     "Position2": "32°47'16.8\"N 35°32'16.1\"E",
//     "Position3": "32°47'16.1\"N 35°32'16.2\"E",
//     "Position4": "32°47'15.9\"N 35°32'15.5\"E"
//   }
// ]